export default __webpack_public_path__ + "static/media/e-ticket1.fb23574f.png";